

export default function MensajeToken({ mensajeError, logout }) {
    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/60 p-4 backdrop-blur-sm animate-fade-in dark:bg-black/70">
            <div
                role="alertdialog"
                aria-modal="true"
                className="w-full max-w-sm overflow-hidden rounded-2xl bg-white text-center shadow-2xl animate-sheet-up dark:bg-slate-900 dark:ring-1 dark:ring-slate-800"
            >
                <div className="px-6 pb-6 pt-8">
                    <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-500 ring-8 ring-amber-50/50 dark:bg-amber-500/10 dark:text-amber-400 dark:ring-amber-500/5">
                        <svg
                            className="h-6 w-6"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                        >
                            <path
                                d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                            ></path>
                        </svg>
                    </span>
                    <h3 className="text-lg font-semibold text-slate-900 dark:text-white">Aviso</h3>
                    <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">{mensajeError}</p>
                </div>
                <div className="border-t border-slate-100 bg-slate-50 px-6 py-4 dark:border-slate-800 dark:bg-slate-900">
                    <button
                        type="button"
                        onClick={logout}
                        className="h-11 w-full rounded-xl bg-brand-600 text-sm font-semibold text-white shadow-sm transition hover:bg-brand-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-500/30 active:scale-[0.99]"
                    >
                        Iniciar sesión
                    </button>
                </div>
            </div>
        </div>
    )
}
